import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useParams } from 'react-router';
import { Icon, Tabs, Title} from '../../../components/components';
import DataVendorInfos from "../../../components/data_vendors/DataVendorInfos";
import DataVendorExtracts from "../../../components/data_vendors/DataVendorExtracts";
import DataVendorStreams from "../../../components/data_vendors/DataVendorStreams";
import DataVendorAudiences from "../../../components/data_vendors/DataVendorAudiences";
import PropTypes from "prop-types";
import isEmpty from 'lodash/isEmpty';
import { useDeleteDataVendorMutation, useGetDataVendorQuery } from '../../../api/dataVendorApiSlice';
import DataVendorUsers from './DataVendorUsers';
import DataVendorCreds from './DataVendorCreds';
import { SendCredsModal } from '../../../components/data_vendors/SendCredsModal';
import { Button } from 'react-bootstrap';
import { useGetDataVendorAwsCredsQuery } from '../../../api/dataVendorAwsCredsApiSlice';
import useActionConfirmation from "../../../components/useActionConfirmation";
import SweetAlert from 'react-bootstrap-sweetalert';


function DataVendor(props) {
  const { t } = useTranslation();
  const key = useParams()["dataVendorKey"];
  const [showCreds, setShowCreds] = useState(false);
  const history = useHistory();
  const { data: dataVendor } = useGetDataVendorQuery(key)
  const [deleteDataVendor] = useDeleteDataVendorMutation(key)
  // const [resetAwsCreds] = useResetAwsCredsMutation(key)
  const [showResetAwsAlert, setShowResetAwsAlert] = useState(false)
  const [showExtractWarning, setShowExtractWarning] = useState(false)
  const { data: credsList = [], isSuccess: credsListIsSuccess } = useGetDataVendorAwsCredsQuery(key)

  const canShowNewCreds = () => ( credsListIsSuccess && credsList.length < 2 )
  const handleEditClick = () => history.push(`/data_vendors/${key}/edit`);

  const handleDelete = () => {
    deleteDataVendor(key).unwrap()
      .then(() => {
        history.push("/data_vendors");
      })
      .catch(error => {})
  }
  const handleResetCredsClick = () => {
    // resetAwsCreds(key).unwrap()
    //   .then(()=>{
    //     setShowResetAwsAlert(false)
    //   })
    //   .catch(error => {})
  }

  const onStreamRowClick = (data) => history.push(`/data_vendors/${key}/streams/${data.key}`)
  const onExtractRowClick = (data) => history.push(`/data_vendors/${key}/extracts/${data.key}`)
  const onAudienceRowClick = (data) => history.push(`/data_vendors/${key}/audiences/${data.key}`)
  const handleNewStream = () => history.push(`/data_vendors/${key}/streams/new`)
  const handleNewExtract = () => history.push(`/data_vendors/${key}/extracts/new`)
  const handleNewUser = () => history.push(`/data_vendors/${key}/users/new`)
  const handleNewAudience = () => history.push(`/data_vendors/${key}/audiences/new`)
  const handleCancel = () => history.push('/data_vendors')

  const {Confirmation, confirmationProps, confirm} = useActionConfirmation()
  const beforeConfirm = () => {
    if( dataVendor.has_extracted_file ) {
      setShowExtractWarning(true)
    } else {
      confirm(handleDelete, dataVendor.name)
    }
  }
  const afterWarningConfirmation = () => {
    confirm(handleDelete, dataVendor.name)
  }

  if (isEmpty(dataVendor)) { return (<></>) }

  return (
    <>
      <Title main={t("menu.data_vendors")} sub={dataVendor.name} group={true} onBack={handleCancel}>
        <Button onClick={handleEditClick}>
          <Icon icon='edit' text={t("edit")} />
        </Button>
        <Button onClick={handleNewStream}>
          <Icon icon='plus' text={t("stream.new")} />
        </Button>
        <Button onClick={handleNewExtract}>
          <Icon icon='plus' text={t("extract.new")} />
        </Button>
        <Button onClick={()=>{setShowResetAwsAlert(true)}}>
          <Icon icon='aws' text={t("dataVendor.reset_creds")} />
        </Button>
        <Button onClick={handleNewUser}>
          <Icon icon='plus' text={t("users.new")} />
        </Button>
        <Button onClick={handleNewAudience}>
          <Icon icon='plus' text={t("audience.new")} />
        </Button>
        <Button onClick={() => confirm(handleDelete, dataVendor.name)}>
          <Icon icon='trash' text={t("delete")} />
        </Button>
        {
          canShowNewCreds() && <Button onClick={()=>setShowCreds(true)}>
            <Icon icon='aws' text={t("dataVendors.send_aws")} />
          </Button>
        }
      </Title>
      {showResetAwsAlert && <SweetAlert warning
                                        showCancel
                                        title={t("confirm?")}
                                        confirmBtnText={t("dataVendor.reset_creds")}
                                        confirmBtnBsStyle="danger"
                                        cancelBtnText={t("cancel")}
                                        cancelBtnBsStyle="light"
                                        onConfirm={handleResetCredsClick}
                                        onCancel={()=>{setShowResetAwsAlert(false)}}>
          {t("irreversible")}
      </SweetAlert>}
      <SendCredsModal show={showCreds} setShow={setShowCreds}/>
      <Tabs active={props.history.location.state?.activeTab}>
        <DataVendorInfos
          as="information"
          icon="info"
          dataVendor={dataVendor}
        />
        <DataVendorStreams
          as="streams"
          icon="stream"
          streams={dataVendor.streams}
          onAdd={handleNewStream}
          onRowClick={onStreamRowClick}
          newButtonContent={<Icon icon='plus' text={t("stream.new")} />}
        />
        <DataVendorExtracts
          as="extracts"
          icon="fileExport"
          extracts={dataVendor.extracts}
          onAdd={handleNewExtract}
          onRowClick={onExtractRowClick}
          newButtonContent={<Icon icon='plus' text={t("extract.new")} />}
        />
        <DataVendorAudiences
          as="audiences"
          icon="audience"
          audiences={dataVendor.audiences}
          onAdd={handleNewAudience}
          onRowClick={onAudienceRowClick}
          newButtonContent={<Icon icon='plus' text={t("audience.new")} />}
        />
        <DataVendorUsers
          as="users"
          icon="users"
          users= {dataVendor.users}
        />
        <DataVendorCreds
          as="awsCredentials"
          creds={credsList}
          icon="aws"
        />
      </Tabs>
      <Confirmation placeholder="Please enter vendor name to confirm" {...confirmationProps} deletion>
        {t("irreversible_with_name", {name: dataVendor.name})} <br/>
      </Confirmation>
      {showExtractWarning && (
        <SweetAlert
          warning
          showCancel
          title="Warning"
          onConfirm={afterWarningConfirmation}
          onCancel={() => setShowExtractWarning(false)}
          cancelBtnText={t("cancel")}
          cancelBtnBsStyle="light"
        >
          {t(
            "dataVendor.delete_with_extracts_warning",
            { s3_prefixes: dataVendor.s3_prefixes.join(', ') }
          )}
        </SweetAlert>
      )}
    </>
  )
}

DataVendor.propTypes = {
  activeTab: PropTypes.oneOf(['information', 'streams', 'extracts'])
}

DataVendor.defaultProps = {
  dataVendor: {}
}

export default DataVendor
